import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography, Chip, Stack, Button, TextField, Pagination } from '@mui/material';

import AccessibilityIcon from "@material-ui/icons/Accessibility";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import CuentaApi from "conten/cuentas/CuentaApiClient";
import axios from "axios";
import { Box, Collapse, Divider, Grid, Paper } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";
import MesaDeAyudaApiHelper from "./MesaDeAyudaApiHelper";
import { ID_CUENTA } from "config/general/Configuracion";
import { ID_PERFIL } from "config/general/Configuracion";

const MesaDeAyuda = ({ classes, addMessage }) => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroPrioridad, setFiltroPrioridad] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroArea, setFiltroArea] = useState("");
  const [expandidoId, setExpandidoId] = useState(null);
  const [expandidoActualizar, setExpandidoActualizar] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = 5;
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [nuevaSolicitud, setNuevaSolicitud] = useState({
    prioridad: "",
    tipo_solicitud: "",
    descripcion_solicitud: "",
    area_a_resolver: "",
    enlace_imagenes_evidencia_solicitud: ""
  });
  const [solicitudActualizar, setSolicitudActualizar] = useState({
    id: '',
    prioridad: '',
    tipo_solicitud: '',
    estado_solicitud: "",
    usuario_soluciona: sessionStorage.getItem("ID_USUARIO"),
    descripcion_solucion: "",
    enlace_imagenes_evidencia_solucion: "",
  });

  const toggleExpand = (id) => {
    setExpandidoId(expandidoId === id ? null : id);
  };

  const toggleChangeState = (solicitud) => {
    setSolicitudActualizar((prev) => ({
      ...prev, id: solicitud.id, prioridad: solicitud.prioridad,
      estado_solicitud: solicitud.estado_solicitud, tipo_solicitud: solicitud.tipo_solicitud, descripcion_solucion: solicitud.descripcion_solucion,
      enlace_imagenes_evidencia_solucion: solicitud.enlace_imagenes_evidencia_solucion
    }));
    setExpandidoActualizar(expandidoActualizar === solicitud ? null : solicitud);
  };

  const handleNuevaSolicitudChange = (campo, valor) => {
    setNuevaSolicitud((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleSolicitudActualizarChange = (campo, valor) => {
    setSolicitudActualizar((prev) => ({ ...prev, [campo]: valor }));
  };


  const filtrarSolicitudes = () => {
    return solicitudes.filter((solicitud) => {
      const coincideTexto = solicitud.descripcion_solicitud.toLowerCase().includes(filtro.toLowerCase());
      const coincideTipo = !filtroTipo || solicitud.tipo_solicitud === parseInt(filtroTipo);
      const coincidePrioridad = !filtroPrioridad || solicitud.prioridad === parseInt(filtroPrioridad);
      const coincideEstado = !filtroEstado || solicitud.estado_solicitud === parseInt(filtroEstado);
      const coincideArea = !filtroArea || solicitud.area_a_resolver === parseInt(filtroArea);

      return coincideTexto && coincideTipo && coincidePrioridad && coincideEstado && coincideArea;
    });
  };

  const obtenerSolicitudesPaginadas = () => {
    const todas = filtrarSolicitudes();
    const inicio = (paginaActual - 1) * elementosPorPagina;
    const fin = inicio + elementosPorPagina;
    return todas.slice(inicio, fin);
  };

  const totalPaginas = Math.ceil(filtrarSolicitudes().length / elementosPorPagina);


  const cuentaId = sessionStorage.getItem("cuenta");


  const handleCrearSolicitud = async () => {
    // Verificar que todos los campos requeridos estén completos
    if (
      nuevaSolicitud.prioridad &&
      nuevaSolicitud.tipo_solicitud &&
      nuevaSolicitud.descripcion_solicitud &&
      nuevaSolicitud.area_a_resolver
    ) {
      try {
        // Crear el objeto de nueva solicitud
        const idUsuario = sessionStorage.getItem("ID_USUARIO") || await obtenerIdUsuario();
        const nueva = {
          prioridad: nuevaSolicitud.prioridad,
          tipo_solicitud: nuevaSolicitud.tipo_solicitud,
          descripcion_solicitud: nuevaSolicitud.descripcion_solicitud,
          usuario_solicita: idUsuario,
          area_a_resolver: nuevaSolicitud.area_a_resolver,
          estado_solicitud: 1,
          descripcion_solucion: "",
          enlace_imagenes_evidencia_solicitud: nuevaSolicitud.enlace_imagenes_evidencia_solicitud || "",
          enlace_imagenes_evidencia_solucion: ""
        };

        // Enviar la solicitud a la API
        const cuenta = sessionStorage[ID_CUENTA];
        await MesaDeAyudaApiHelper.guardarSolicitud(cuenta, nueva);

        listarSolicitudesdDesdeApi();

        // Limpiar el formulario
        setNuevaSolicitud({
          prioridad: "",
          tipo_solicitud: "",
          descripcion_solicitud: "",
          area_a_resolver: "",
          enlace_imagenes_evidencia_solicitud: ""
        });

        setPaginaActual(1);

        // Mostrar mensaje de éxito
        addMessage({
          variant: "success",
          message: `La solicitud ha sido creada correctamente.`,
        });
      } catch (error) {
        console.error("Error al guardar la solicitud:", error);
        addMessage({
          variant: "danger",
          message: `Ocurrió un error al crear la solicitud. Por favor intenta de nuevo.`,
        });
      }
    } else {
      addMessage({
        variant: "warning",
        message: `Por favor completa todos los campos obligatorios para crear la solicitud.`,
      });
    }
  };

  const handleActualizarSolicitud = async () => {
    try {
      // Verificar que la solicitud a actualizar tenga un ID
      if (!solicitudActualizar.id) {
        console.error("❌ No se puede actualizar sin un ID de solicitud");
        return;
      }

      // Confirmar si el estado es 3 (Resuelta) o 4 (Cerrada)
      if (solicitudActualizar.estado_solicitud > 2) {
        const confirmar = window.confirm(
          solicitudActualizar.estado_solicitud === 3
            ? "¿Estás seguro de que deseas marcar esta solicitud como resuelta?"
            : "¿Estás seguro de que deseas cerrar esta solicitud?"
        );

        if (!confirmar) return;
      }

      // Crear el objeto de actualización
      const idUsuario = sessionStorage.getItem("ID_USUARIO") || await obtenerIdUsuario();
      const payload = {
        id: solicitudActualizar.id,
        prioridad: solicitudActualizar.prioridad,
        tipo_solicitud: solicitudActualizar.tipo_solicitud,
        estado_solicitud: solicitudActualizar.estado_solicitud === 1 ? 2 : solicitudActualizar.estado_solicitud,
        usuario_soluciona: idUsuario,
        descripcion_solucion: solicitudActualizar.descripcion_solucion || "",
        enlace_imagenes_evidencia_solucion: solicitudActualizar.enlace_imagenes_evidencia_solucion || ""
      };

      // Enviar la actualización a la API
      const cuenta = sessionStorage[ID_CUENTA];
      await MesaDeAyudaApiHelper.guardarSolicitud(cuenta, payload);

      // Refrescar la lista de solicitudes
      listarSolicitudesdDesdeApi();

      // Mostrar mensaje de éxito
      addMessage({
        variant: "success",
        message: `La solicitud ha sido actualizada correctamente.`,
      });

    } catch (error) {
      const mensajeError = error.response?.data || "Ocurrió un error al actualizar la solicitud. Por favor intenta de nuevo.";
      console.error("❌ Error al actualizar la solicitud:", error);
      addMessage({
        variant: "danger",
        message: mensajeError,
      });
    }
  };

  useEffect(() => {
    setPaginaActual(1);
  }, [filtro, filtroTipo, filtroPrioridad, filtroEstado, filtroArea]);

  useEffect(() => {
    if (cuentaId) {
      // Función asíncrona para manejar las solicitudes
      const cargarLimitesYUsuario = async () => {
        try {
          // Consultar límites de la cuenta
          const results = await Promise.allSettled([
            axios(CuentaApi.listarMaxPlacaExenta(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxZonas(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesAdministrador(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesSupervisor(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesAuxiliar(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesMunicipio(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesVisor(cuentaId)).then((r) => r.data),
            axios(CuentaApi.listarMaxPerfilesPromotor(cuentaId)).then((r) => r.data),
          ]);

          const keys = [
            "LIMITE_MAX_PLACA_EXENTA",
            "LIMITE_MAX_ZONAS",
            "LIMITE_MAX_PERFILES_ADMINISTRADOR",
            "LIMITE_MAX_PERFILES_SUPERVISOR",
            "LIMITE_MAX_PERFILES_AUXILIAR",
            "LIMITE_MAX_PERFILES_MUNICIPIO",
            "LIMITE_MAX_PERFILES_VISOR",
            "LIMITE_MAX_PERFILES_PROMOTOR",
          ];

          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              sessionStorage.setItem(keys[index], result.value);
            } else {
              console.warn(`❌ Error consultando ${keys[index]}:`, result.reason);
              sessionStorage.setItem(keys[index], null); // o puedes omitirlo
            }
          });

          // Consultar ID del usuario
          const usuarioData = await MesaDeAyudaApiHelper.obtenerIdUsuario();

          // Verificar que el ID sea válido antes de setearlo
          if (usuarioData) {
            sessionStorage.setItem("ID_USUARIO", usuarioData);
            console.log("✅ ID del usuario:", usuarioData);
          } else {
            console.error("❌ No se pudo obtener el ID del usuario.");
          }

        } catch (error) {
          console.error("❌ Error al cargar límites o ID de usuario:", error);
        }
      };

      cargarLimitesYUsuario();
    }
  }, [cuentaId]);

  const listarSolicitudesdDesdeApi = async () => {
    MesaDeAyudaApiHelper.listarSolicitudes(cuentaId, 100, paginaActual)
      .then((response) => {
        setSolicitudes(response.solicitudes);
      })
      .catch((error) => {
        console.error("Error al listar solicitudes:", error);
        addMessage({
          variant: "danger",
          message: `Error al listar solicitudes: ${error.message}`,
        });
      });
  }

  useEffect(() => {
    listarSolicitudesdDesdeApi();
  }, []);

  const tipoSolicitud = [
    { id: 1, nombre: "Error" },
    { id: 2, nombre: "Correccion" },
    { id: 3, nombre: "Mejora" },
    { id: 4, nombre: "Sugerencia" },
    { id: 5, nombre: "App Ciudadana" },
  ]

  const areaSolicitud = [
    { id: 1, nombre: "Plataforma web" },
    { id: 2, nombre: "Base de datos" },
    { id: 3, nombre: "Funcional" },
    { id: 4, nombre: "Dispositivo movil" },
    { id: 5, nombre: "Impresora" },
    { id: 6, nombre: "Administrativo" },
    { id: 7, nombre: "Financiero" },
    { id: 8, nombre: "Consulta general" },
    { id: 9, nombre: "Ciudad" },
  ]

  const tipoPrioridad = [
    { id: 1, nombre: 'Alta', color: 'error' },
    { id: 2, nombre: 'Media', color: 'warning' },
    { id: 3, nombre: 'Baja', color: 'info' },
  ]

  const estadoSolicitud = [
    { id: 1, nombre: "Nuevo" },
    { id: 2, nombre: "En progreso" },
    { id: 3, nombre: "Resuelto" },
    { id: 4, nombre: "Cerrado" }
  ];

  const getPrioridad = (id) => tipoPrioridad.find((e) => e.id === id) || {};

  const getArea = (id) => areaSolicitud.find((e) => e.id === id) || {};

  const getTipoSolicitud = (id) => tipoSolicitud.find((e) => e.id === id) || {};

  const getEstado = (id) => estadoSolicitud.find((e) => e.id === id) || {};

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="info">
            <AccessibilityIcon />
          </CardIcon>
          <TituloPagina2 texto="Mesa de Ayuda" classes={classes} />
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
            <Grid item xs={12} md={3}>
              <TextField
                label="Buscar por descripción"
                variant="outlined"
                fullWidth
                size="small"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                label="Prioridad"
                select
                fullWidth
                size="small"
                value={filtroPrioridad}
                onChange={(e) => setFiltroPrioridad(e.target.value)}
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
              >
                <option value="">Todas</option>
                {tipoPrioridad.map((op) => (
                  <option key={op.id} value={op.id}>{op.nombre}</option>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                label="Tipo de solicitud"
                select
                fullWidth
                size="small"
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
              >
                <option value="">Todos</option>
                {tipoSolicitud.map((op) => (
                  <option key={op.id} value={op.id}>{op.nombre}</option>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                label="Estado solicitud"
                select
                fullWidth
                size="small"
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
              >
                <option value="">Todos</option>
                {estadoSolicitud.map((op) => (
                  <option key={op.id} value={op.id}>{op.nombre}</option>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Área de solicitud"
                select
                fullWidth
                size="small"
                value={filtroArea}
                onChange={(e) => setFiltroArea(e.target.value)}
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
              >
                <option value="">Todas</option>
                {areaSolicitud.map((op) => (
                  <option key={op.id} value={op.id}>{op.nombre}</option>
                ))}
              </TextField>
            </Grid>
          </Grid>
          {["101", "102", "106"].includes(sessionStorage[ID_PERFIL]) && (
            <Button
              fullWidth
              variant="contained"
              style={{
                backgroundColor: "#162F4A",
                color: "#f0f4f8",
                marginBottom: "1rem",
                borderRadius: "6px",
                boxShadow: "none",
                textTransform: "none",
                fontWeight: "bold"
              }}
              onClick={() => setMostrarFormulario(!mostrarFormulario)}
              endIcon={mostrarFormulario ? <ExpandLess /> : <ExpandMore />}
            >
              {mostrarFormulario ? "Cerrar" : "Crear nueva solicitud"}
            </Button>)}
          <Collapse in={mostrarFormulario}>

            <Paper
              elevation={1}
              style={{
                padding: "1rem",
                marginBottom: "1rem",
                border: "1px dashed #aaa",
                backgroundColor: "#f0f4f8"
              }}
            >
              <Typography variant="subtitle1" gutterBottom>Crear nueva solicitud</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Prioridad"
                    select
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.prioridad}
                    onChange={(e) => handleNuevaSolicitudChange("prioridad", parseInt(e.target.value))}
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <option value="" disabled={true}>Selecciona</option>
                    {tipoPrioridad.map((op) => (
                      <option key={op.id} value={op.id}>{op.nombre}</option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Tipo"
                    select
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.tipo_solicitud}
                    onChange={(e) => handleNuevaSolicitudChange("tipo_solicitud", parseInt(e.target.value))}
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <option value="" disabled={true}>Selecciona</option>
                    {tipoSolicitud.map((op) => (
                      <option key={op.id} value={op.id}>{op.nombre}</option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Área"
                    select
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.area_a_resolver}
                    onChange={(e) => handleNuevaSolicitudChange("area_a_resolver", parseInt(e.target.value))}
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <option value="" disabled={true}>Selecciona</option>
                    {areaSolicitud.map((op) => (
                      <option key={op.id} value={op.id}>{op.nombre}</option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Descripción"
                    multiline
                    rows={2}
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.descripcion_solicitud}
                    onChange={(e) => handleNuevaSolicitudChange("descripcion_solicitud", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="URL imagen evidencias(opcional)"
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.enlace_imagenes_evidencia_solicitud}
                    onChange={(e) => handleNuevaSolicitudChange("enlace_imagenes_evidencia_solicitud", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleCrearSolicitud}
                    style={{ height: "100%", backgroundColor: "#162F4A", color: "white" }}
                  >
                    Crear solicitud
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Collapse>

          {obtenerSolicitudesPaginadas().map((solicitud, index) => (
            <Paper
              key={solicitud.id}
              elevation={0}
              style={{
                padding: "1rem",
                backgroundColor: index % 2 === 1 ? "#f1f5f9" : "#ffffff"
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                  <Typography variant="h6">{getTipoSolicitud(solicitud.tipo_solicitud).nombre}</Typography>

                  <Typography variant="body1">{getArea(solicitud.area_a_resolver).nombre}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Reportado por: {solicitud.nombre_usuario_solicita}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Fecha: {new Date(solicitud.fecha_solicitud).toLocaleString()}
                  </Typography>

                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" spacing={1} marginBottom={1}>
                    <Chip
                      label={getPrioridad(solicitud.prioridad).nombre}
                      color={getPrioridad(solicitud.prioridad).color}
                    />
                    <Chip
                      label={getEstado(solicitud.estado_solicitud).nombre}
                      variant="outlined"
                      color="primary"
                      onClick={() => toggleChangeState(solicitud)}
                    />
                  </Stack>
                  <Button
                    size="small"
                    variant="contained"
                    style={{
                      backgroundColor: "#162F4A",
                      color: "white",

                    }}
                    onClick={() => toggleExpand(solicitud.id)}
                    endIcon={expandidoId === solicitud.id ? <ExpandLess /> : <ExpandMore />}
                  >
                    {expandidoId === solicitud.id ? "Ocultar Detalles" : "Ver Detalle"}
                  </Button>
                </Grid>
              </Grid>

              <Collapse in={expandidoId === solicitud.id}>
                <Divider style={{ margin: "1rem 0" }} />
                <Typography variant="subtitle2">{solicitud.descripcion_solicitud}</Typography>
                {solicitud.tipo_solicitud === 5 &&
                  solicitud.enlace_imagenes_evidencia_solicitud &&
                  solicitud.enlace_imagenes_evidencia_solicitud.startsWith("data:image/") ? (
                  <Box mt={2}>
                    <Typography variant="body2" gutterBottom>
                      Imagen reportada:
                    </Typography>
                    <img
                      src={solicitud.enlace_imagenes_evidencia_solicitud}
                      alt="Evidencia App Ciudadana"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "300px",
                        borderRadius: "4px",
                        border: "1px solid #ccc"
                      }}
                    />
                  </Box>
                ) :
                  (
                    <a
                      href={solicitud.enlace_imagenes_evidencia_solicitud}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1a73e8", textDecoration: "underline" }}
                    >
                      Ver evidencia de solicitud
                    </a>
                  )
                }

                <Box marginTop={2}>
                  <Typography variant="subtitle2">Solución aplicada:</Typography>
                  <Typography variant="body2">
                    {solicitud.descripcion_solucion || "Aún sin solución registrada."}
                  </Typography>
                  {solicitud.nombre_usuario_soluciona && (
                    <Typography variant="body2" color="textSecondary">
                      Solucionado por: {solicitud.nombre_usuario_soluciona}<br />
                      Fecha: {new Date(solicitud.fecha_solucion).toLocaleString()}
                    </Typography>

                  )}
                  {solicitud.enlace_imagenes_evidencia_solucion && (
                    <a
                      href={solicitud.enlace_imagenes_evidencia_solucion}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1a73e8", textDecoration: "underline" }}
                    >
                      Ver evidencia de solución
                    </a>
                  )}
                </Box>
              </Collapse>
              <Collapse in={expandidoActualizar === solicitud && solicitud.estado_solicitud < 3}>
                <Paper
                  elevation={1}
                  style={{
                    padding: "1rem",
                    marginBottom: "1rem",
                    border: "1px dashed #aaa",
                    backgroundColor: "#f0f4f8"
                  }}
                >
                  <Typography variant="subtitle1" gutterBottom>Actualizar solicitud</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <TextField
                        label="Prioridad"
                        select
                        fullWidth
                        size="small"
                        value={solicitudActualizar.prioridad}
                        onChange={(e) => handleSolicitudActualizarChange("prioridad", parseInt(e.target.value))}
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                      >
                        {tipoPrioridad.map((op) => (
                          <option key={op.id} value={op.id}>{op.nombre}</option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        label="Estado"
                        select
                        fullWidth
                        size="small"
                        value={solicitudActualizar.estado_solicitud === 1 ? 2 : solicitudActualizar.estado_solicitud}
                        onChange={(e) => handleSolicitudActualizarChange("estado_solicitud", parseInt(e.target.value))}
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                      >
                        {estadoSolicitud.map((op) => (
                          <option key={op.id} value={op.id}>{op.nombre}</option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Descripción"
                        multiline
                        rows={2}
                        fullWidth
                        size="small"
                        value={solicitudActualizar.descripcion_solucion}
                        onChange={(e) => handleSolicitudActualizarChange("descripcion_solucion", e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="URL imagen evidencias(opcional)"
                        fullWidth
                        size="small"
                        value={solicitudActualizar.enlace_imagenes_evidencia_solucion}
                        onChange={(e) => handleSolicitudActualizarChange("enlace_imagenes_evidencia_solucion", e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleActualizarSolicitud}
                        style={{ height: "100%", backgroundColor: "#162F4A", color: "white" }}
                      >
                        Actualizar Solicitud
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Collapse>
            </Paper>
          ))}
        </CardBody>
        <Box display="flex" justifyContent="center" marginTop={2} marginBottom={2}>
          <Pagination
            count={totalPaginas}
            page={paginaActual}
            onChange={(e, value) => setPaginaActual(value)}
            style={{ backgroundColor: "white", color: "#162F4A" }}
            shape="rounded"
          />
        </Box>
      </Card>
    </GridItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    null,
    mapDispatchToProps
  )(MesaDeAyuda)
);